<template>
  <div class="import-progress">
    <p class="progress-subtitle">{{ message }}</p>

    <div class="progress-row">
      <div
        class="progress-bar"
        role="progressbar"
        :aria-valuenow="done"
        :aria-valuemin="0"
        :aria-valuemax="total"
      >
        <div class="progress-bar-fill" :style="{ width: percent + '%' }" />
      </div>
      <div class="progress-count">{{ done }} / {{ total }}</div>
    </div>

    <div v-if="error" class="progress-error">{{ error }}</div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue";

export default defineComponent({
  name: "ImportProgress",
  props: {
    message: { type: String, required: true },
    done: { type: Number, required: true },
    total: { type: Number, required: true },
    error: {
      type: String as PropType<string | null>,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const percent = computed(() => {
      const total = Math.max(0, Math.floor(props.total));
      const done = Math.max(0, Math.floor(props.done));
      if (!total) return 0;
      return Math.max(0, Math.min(100, Math.round((done / total) * 100)));
    });

    return { percent };
  },
});
</script>

<style scoped lang="scss">
.import-progress {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  min-width: 0;
  max-width: 100%;
}

.progress-subtitle {
  min-width: 0;
  overflow-wrap: break-word;
  max-width: 460px;
}

.progress-bar {
  flex: 1;
  height: 6px;
  border-radius: 999px;
  overflow: hidden;
  @include themed() {
    background: t($grey-10);
  }
}

.progress-bar-fill {
  height: 100%;
  @include transition(width 150ms linear);
  @include themed() {
    background: t($primary);
  }
}

.progress-row {
  display: flex;
  align-items: center;
  column-gap: 10px;
  flex: 1;
}

.progress-count {
  @extend %font-caption-regular;
  white-space: nowrap;
  @include themed() {
    color: t($grey-60);
  }
}

.progress-error {
  min-width: 0;
  overflow-wrap: break-word;
  max-width: 460px;
  @extend %font-caption-regular;
  @include themed() {
    color: t($secondary-50);
  }
}
</style>
